export const LOGIN = '/admin/login';
export const DASHBOARD_STATUS = '/dashboard/status';
export const DASHBOARD_REVENUE = '/dashboard/earnings';
export const DASHBOARD_REVENUE_OVERVIEW = '/dashboard/grossRevenue';
export const DASHBOARD_ERROR_OVERVIEW = '/dashboard/errorsOverview';
export const DASHBOARD_RECURRING_USERS = '/dashboard/recurringUsers';
export const DASHBOARD_SELLER_COMMISSION = '/dashboard/sellerCommission';
export const DASHBOARD_COUNTRY_REVENUE = '/dashboard/countryRevenue';
export const FORGOT_PASSWORD = '/admin/forgot-password';
export const RESET_PASSWORD = '/admin/reset-password';
export const EDIT_ADMIN_PROFILE = '/admin/profile/update';
export const UPDATEPROFILE = '/user/userInfo';
export const EDIT_PROFILE = '/user/edit-profile';
export const ADMINUSERLIST = '/admin/list';
export const ADMINUSERDELETE = '/admin/delete';
export const ADMINADDUSER = '/admin/create';
export const ADMINUSEREDIT = '/admin/update';
export const ADMINDETAILUSER = '/admin';
export const ADMIN_ACTIVITY_LOG = '/admin/activity-log';
export const ADMIN_LOGOUT = '/admin/logout';
export const USERLIST = '/user/list';
export const USER = '/user';
export const MERCHANTLIST = '/merchant/list';
export const MERCHANT_MAINTENANCE = '/merchant/maintenance';
export const MERCHANT_TEMPORARY_CLOSE = '/merchant/temporary-close';
export const MERCHANT_COMING_SOON = '/merchant/coming-soon';
export const MERCHANT_BULK_HIDE = '/merchant/bulk-hide';
export const MERCHANT_ARCHIVE = '/merchant/archive';
export const MERCHANTNAMELIST = '/merchant/nameList';
export const MERCHANT = '/merchant';
export const LOCATION_GENERATE = '/merchant/locationId';
export const MERCHANT_BULK_UPLOAD = '/merchant/bulk-upload';
export const MERCHANT_BULK_UPLOAD_STATUS = '/merchant/bulk-upload/status';
export const MERCHANT_BULK_UPLOAD_TEMPLATE = '/merchant/bulk-upload/template';
export const STATIONLIST = '/station/list';
export const STATION_SUMMARY = '/station/summary';
export const STATION = '/station';
export const POWERBANKLIST = '/powerbank/list';
export const POWERBANK = '/powerbank';
export const STATION_STATUS = '/station/status';
export const EJECT_POWERBANK = '/order/maintenance';
export const STATION_ATTENTION = '/station/attention';
export const ORDERLIST = '/order/list';
export const DOWNLOAD_ORDER_EXCEL = '/order/export-csv';
export const ORDER = '/order';
export const SYNCDATAORDER = '/sync-data/orders';
export const SYNCDATAMERCHANT = '/sync-data/merchant';
export const SYNC_MERCHANT_SHEET = '/sync-data/merchant-sheet';
export const SYNC_STATION_SHEET = '/sync-data/station-sheet';
export const MERCHANTDEACTIVATE = '/merchant/deactivate';
export const ERRORLOG_LIST = '/error-log/list';
export const REGION = '/region';
export const PROFITABILITY_GROSS_REVENUE = '/analysis/profitability';
export const SETTLEMENTS = '/analysis/settlements';
export const DOWNLOAD_SETTLEMENT = '/analysis/settlements/download';
export const DOWNLOAD_INVOICE = '/analysis/invoice/download';
export const DOWNLOAD_INVOICE_BULK = '/analysis/invoice/download/bulk';
export const DOWNLOAD_SELLER_INVOICE = '/analysis/seller-invoice/download';
export const SEND_INVOICE = '/analysis/invoice/email';
export const SEND_INVOICE_BULK = '/analysis/invoice/email/bulk';
export const INVOICE_GENERATE_BULK_STORE =
  '/analysis/invoice/generate/bulk/store';
export const ORDER_INVOICE = '/order/invoice';
export const CREDIT_INVOICE = '/order/credit-invoice';
export const MERCHANT_INFO = '/merchant/merchantInfo';
export const MERCHANT_WITH_STATION_COUNT = '/merchant/list-with-station-count';
export const GROUPS = '/filter-groups';
export const COUPON = '/coupon';
export const COUPONSLIST = '/coupon/list';
export const EINVOICE_MERCHANT = '/e-invoice/merchant-invoices';
export const EINVOICE_CUSTOMER = '/e-invoice/customer-invoices';
export const EINVOICE = '/e-invoice';
export const EINVOICE_SALES_PARTNER_LIST = '/analysis/seller-invoice/list';
export const EINVOICE_SALES_PARTNER_DOWNLOAD =
  '/analysis/seller-invoice/download';
export const EINVOICE_SALES_PARTNER_PDF = '/analysis/seller-invoice';
export const PRICE_STRATEGY = '/price-strategy';
export const PRICE_STRATEGY_REGION_LIST = '/price-strategy/region/list';
export const PRICE_STRATEGY_MIGRATE_MERCHANTS =
  '/price-strategy/migrate-merchants';
export const PAYOUT_SETTING = '/payout-setting';
export const PAYOUT_SETTING_STRIPE_ACCOUNTS = '/payout-setting/stripe-accounts';
export const PAYOUT_LOG = '/payout-log';
export const STRIPE_CONNECTED_ACCOUNTS = '/stripe-connected-account/active';
export const STRIPE_CONNECTED_ACCOUNT_ASSIGN = '/stripe-connected-account';
export const STRIPE_CONNECTED_ACCOUNT_REMOVE = '/stripe-connected-account';
